(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('customDateFilterEditor', ['QuickFilterEditorModel', 'CustomDateFilter', function (QuickFilterEditorModel, CustomDateFilter) {
    return {
      templateUrl: 'modules/app/quick-filter/custom-date/custom-date-filter-editor-partial.html',
      replace: true,
      link: function link($scope) {
        $scope.customDateFilter = CustomDateFilter;
      }
    };
  }]);
})();
